import { useState } from 'react';

import Box from '@zenbusiness/zui/Box';
import IconButton from '@zenbusiness/zui/IconButton';
import InputAdornment from '@zenbusiness/zui/InputAdornment';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';
import TextField from '@zenbusiness/zui/TextField';
import PropTypes from 'prop-types';

import { SSN_INVALID_MESSAGE } from './constants/errorMessages';

export default function Ssn({ handleChange, handleShow, values, disabled }) {
  const [state, setState] = useState({ isDirty: false, isFocus: false });
  const isShowError = !values.noSsn && state.isDirty && !state.isFocus && !values.valid;

  const IsDisable = disabled || values.noSsn;

  const hideShowButton = IsDisable ? null : (
    <InputAdornment position="end">
      <IconButton
        edge="end"
        label="toggle ssn visibility"
        onClick={handleShow}
      >
        {values.showSsn ? (
          <SharedAsset
            alt=""
            src="/icon/micro/eye-simple-hide.svg"
          />
        ) : (
          <SharedAsset
            alt=""
            src="/icon/micro/eye-simple-show.svg"
          />
        )}
      </IconButton>
    </InputAdornment>
  );

  const inputNumberOnly = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <Box>
      <TextField
        disabled={IsDisable}
        error={isShowError}
        fullWidth
        id="ssn"
        InputProps={{
          endAdornment: hideShowButton
        }}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{
          maxLength: 9,
          inputMode: 'numeric'
        }}
        label="SSN or ITIN"
        onBlur={() => setState({ ...state, isDirty: true, isFocus: false })}
        onChange={handleChange}
        onFocus={() => setState({ ...state, isFocus: true })}
        onKeyPress={inputNumberOnly}
        type={values.showSsn ? 'text' : 'password'}
        value={values.ssn ?? ''}
      />
      {isShowError && (
        <Text
          color="red"
          component="div"
          pt="8px"
          size="xs"
        >
          {SSN_INVALID_MESSAGE}
        </Text>
      )}
    </Box>
  );
}

Ssn.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleShow: PropTypes.func.isRequired,
  values: PropTypes.shape({
    ssn: PropTypes.string,
    showSsn: PropTypes.bool,
    valid: PropTypes.bool,
    noSsn: PropTypes.bool
  }).isRequired,
  disabled: PropTypes.bool
};
